<template>
  <main class="about" v-if="payload">
    <div class="about__description paragraph-rules">
      <p v-html="payload.description"></p>
      <a
        class="about__description-msd"
        href="https://msd.unimelb.edu.au/"
        target="_blank"
        rel="noopener noreferrer">
        <img src="/images/Uni Melb MSD Logo Tile.png" />
      </a>
    </div>
    <div class="about__contact">
      <p v-html="payload.contact"></p>
    </div>
    <div class="about__awards" v-if="payload.press || payload.highlights">
      <p class="ttu">Awards</p>
      <p v-html="payload.press"></p>
      <ul class="about__awards-list">
        <li v-for="(highlight, key) in payload.highlights" :key="`highlight${key}`">
          <a :href="highlight.link" target="_blank" rel="noopener noreferrer" v-html="hightlight.text" v-if="highlight.link"></a>
          <span v-html="highlight.text" v-else></span>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'

export default {
  name: 'About',
  extends: ApiPage,
  components: {
  },
  data() {
    return {
      payload: null
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  @include page;
  display:flex;
  flex-wrap:wrap;
  &__contact, &__description {
    width:50%;
    padding:0 $grid-padding 0 0;
  }

  &__description-msd {
    display:inline-block;
    margin:20px 0;
  }

  &__awards {
    width:50%;
    padding:2rem $grid-padding 0 0;
    h3 {

    }
    &-list {
      li {
        padding:0 0 0 1.5rem;
        position: relative;
        &:before {
          content:'-';
          display:block;
          position: absolute;
          left:0;
        }
      }
    }
  }

  @media screen and (max-width: $mobile) {
    display:flex;
    flex-wrap: wrap;
    &__contact, &__description, &__awards {
      width:100%;
      p {
        font-size:$body--m;
      }
    }
    &__description {
      margin:0 0 2rem 0;
    }
  }
}
</style>
